import { Dispatch, SetStateAction, useEffect } from 'react';

import { FAIconName } from '@equip.health/ui';

import ConfirmModal from '~/components/common/ConfirmModal';
import { useDeleteAssessmentMutation } from '~/store/services/assessments';

type Props = {
  assessmentId: string;
  setAssessmentId: Dispatch<SetStateAction<string>>;
};
export const DeleteAssessmentConfirmModal = ({
  assessmentId,
  setAssessmentId,
}: Props) => {
  const [
    deleteAssessmentMutation,
    {
      isLoading: isDeleteAssessmentLoading,
      isSuccess: isDeleteAssessmentSuccess,
    },
  ] = useDeleteAssessmentMutation();
  useEffect(() => {
    if (isDeleteAssessmentSuccess) {
      setAssessmentId('');
    }
  }, [isDeleteAssessmentLoading, isDeleteAssessmentSuccess]);
  return (
    <ConfirmModal
      body="Are you sure you want to delete this assessment instance? This action cannot be undone."
      cancelIcon={FAIconName.XmarkRegular}
      cancelLabel="Cancel"
      confirmIcon={FAIconName.trashRegular}
      confirmLabel="Delete"
      confirmVariant="accent.critical"
      isLoading={isDeleteAssessmentLoading}
      isOpen={assessmentId !== ''}
      onClose={() => setAssessmentId('')}
      onConfirm={() => {
        deleteAssessmentMutation(assessmentId);
      }}
      title="Delete assessment"
    />
  );
};
